export default "__VITE_ASSET__a2c51031__"